// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './Answer.vue';
import router from './router';
import store from './stores';
// Install global dependency & dependency injection.
import injection from './lib/installer';
import '@/assets/less/global.less';

Vue.config.productionTip = false;
Vue.use(injection);

injection.store = store;
injection.router = router;
/* eslint-disable no-new */
injection.Vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});
